import OktaAuth, {
  IDToken,
  TokenManagerInterface,
  toRelativeUrl,
} from '@okta/okta-auth-js';

import { oktaConfig } from '../configs';

export const oktaAuthClient = new OktaAuth(oktaConfig);

const tokenManager: TokenManagerInterface = oktaAuthClient.tokenManager;

export const getRelativeUrl = (
  url: string,
  baseUrl: string = window.location.origin
) => {
  return toRelativeUrl(url, baseUrl);
};
export const getIdToken = async () =>
  (await tokenManager.get('idToken')) as IDToken;
export const renewToken = async () => {
  const renewToken = await oktaAuthClient.token.renewTokens();
  await tokenManager.setTokens(renewToken);
  return renewToken;
};
export const oktaSignout = async () => {
  return await oktaAuthClient.signOut({
    clearTokensBeforeRedirect: true,
    postLogoutRedirectUri: window.location.origin,
  });
};
export default oktaAuthClient;
